module.exports = __webpack_public_path__ + "files/b5155aba93d3421fdfae50286bcb65a9.woff";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/lato-italic-webfont.woff
// module id = 688
// module chunks = 60